module.exports = __webpack_public_path__ + "media/images/icons/star-396b6360abc5844ec9bc3e7968b96936.svg";